import { render, staticRenderFns } from "./sendGood.vue?vue&type=template&id=31eb9e51&scoped=true"
import script from "./sendGood.vue?vue&type=script&lang=js"
export * from "./sendGood.vue?vue&type=script&lang=js"
import style0 from "./sendGood.vue?vue&type=style&index=0&id=31eb9e51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb9e51",
  null
  
)

export default component.exports